import { PerformanceClient, IPerformanceClient } from '@agoda/performance-client';
import { IMessagingClient } from '@agoda/messaging-client';
import { IPerformanceService } from './types';
import { AppContextData } from '@contexts/app/AppContextData';
import { Member } from '@contexts/member/MemberContext';

export class PerformanceService implements IPerformanceService {
    private readonly client: IPerformanceClient;

    constructor(messagingClient: IMessagingClient, appContext: AppContextData, member: Member | null) {
        this.client = new PerformanceClient(messagingClient, {
            clientId: 1, // ExpPlatform Client ID (1 for client-side)
            pageTypeId: 221, // Login page type
            devicePlatformId: appContext.devicePlatformId,
            userId: appContext.userId,
            cid: appContext.cid,
            languageId: appContext.languageId,
            whiteLabelId: appContext.whitelabelId,
            memberId: member ? member.id : 0,
            trafficGroupId: appContext.trafficGroupId,
            aid: appContext.aid,
            origin: appContext.origin,
        });
    }

    private resourceAggregates = [
        {
            metric: 'SCRIPT',
            initiatorType: ['script'],
            urlPattern: /\/js\/ul\/client-side\/.*\.js/gi,
        },
        {
            metric: 'FONT',
            initiatorType: ['css', 'other'],
            urlPattern: /cdn\d*\..*\/fonts\/(?!icons).*\.(eot|woff2?|ttf|svg)/gi,
        },
        {
            metric: 'ICON',
            initiatorType: ['css', 'other'],
            urlPattern: /cdn\d*\..*\/fonts\/icons.*\.woff2?/gi,
        },
        {
            metric: 'IMG',
            initiatorType: ['img'],
            urlPattern: /pix\d*\./gi,
        },
        {
            metric: 'STYLE',
            initiatorType: ['css', 'link'],
            urlPattern: /.*\.css/gi,
        },
    ];

    public measureLanding() {
        const visuallyComplete = this.client.measureVisuallyComplete({}, false, {});
        visuallyComplete.await().then(r => {
            if (r.result) {
                return r.result.moment.value;
            }
        });
        this.client.measureDocumentLoad(visuallyComplete.await());
        this.client.measurePaintFirst(visuallyComplete.await());
        this.client.measureInteractive(visuallyComplete.await());
        this.client.measureResourceAggregates(visuallyComplete.await(), this.resourceAggregates, {}, false, {
            isWithSize: false,
        });
        this.client.measureClickFirst();
        this.client.measureScrollFirst();
        this.client.measurePaintLargest();
        this.client.measureInputFirstDelay();
        this.client.measureCumulativeLayoutShift(visuallyComplete.await(), {});
    }
}
